import './App.css';
import React,{useEffect,useContext} from "react";
import { Routes, Route } from "react-router-dom";
import Login from "./components/Login";
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import 'antd/dist/antd.min.css';
import authContext from "./context/auth/authContext";
import Reports from "./components/Reports";

function App() {
    const auth = useContext(authContext);
    const {loadUser} = auth;
    useEffect(() => {
        loadUser();
    }, [])
  return (
    <>
        <Navbar/>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/updater" element={<Home />} />
        <Route path="/reports" element={<Reports />} />
      </Routes>
    </>
  );
}

export default App;
